import { CenteredLayout } from '#packages/web/foundations/layouts/centered-layout';

import { auditService } from '#apps/client-web/features/audit/services/audit';
import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';
import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { clock } from '#apps/client-web/app/services/clock';
import { FormPageLayout } from '#apps/client-web/app/components/form-page-layout';

import { AuditSettingsPageContainer } from './audit-settings-page.container';
import { useAuditSettingsPageViewModel } from './audit-settings-page.view-model';

export const AuditSettingsPage = () => {
  const logger = useLogger('pages/audit-settings');

  const viewModel = useAuditSettingsPageViewModel({
    auditService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    clock,

    logger,
  });

  return (
    <FormPageLayout
      title="Audit Settings"
      isFormChanged={viewModel.form.formState.isDirty}
      onSubmit={viewModel.onSubmit}
      isSubmitDisabled={viewModel.updateMutationState.state === 'pending'}>
      <CenteredLayout horizontal>
        <AuditSettingsPageContainer viewModel={viewModel} />
      </CenteredLayout>
    </FormPageLayout>
  );
};
